import { useState, useEffect } from "react";

export const useNavHover = () => {
  const [navHover, setNavHover] = useState(false);

  useEffect(() => {
    const handleOver = (e) => {
      const hoveredItem = e.target.closest && e.target.closest(".submenu-item");
      if (hoveredItem) {
        setNavHover(true);
        hoveredItem.parentElement
          .querySelectorAll(".submenu-item")
          .forEach((sib) => {
            if (sib !== hoveredItem) sib.classList.add("nav-dim");
          });
      }
    };
    const handleOut = (e) => {
      const hoveredItem = e.target.closest && e.target.closest(".submenu-item");
      if (hoveredItem) {
        hoveredItem.parentElement
          .querySelectorAll(".submenu-item.nav-dim")
          .forEach((el) => el.classList.remove("nav-dim"));
      }
      if (!document.querySelector(".submenu-item:hover")) setNavHover(false);
    };
    document.addEventListener("pointerover", handleOver, { passive: true });
    document.addEventListener("pointerout", handleOut, { passive: true });

    return () => {
      document.removeEventListener("pointerover", handleOver);
      document.removeEventListener("pointerout", handleOut);
    };
  }, []);

  return navHover;
};
